import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { Step, Workflow } from './Workflow';
import useFeature from 'hooks/useFeature';
import { selectPrequalOffer } from 'state/prequalOffer';
import { FeatureGroups } from 'state/tenant';
import useResponsiveQuery from 'hooks/useResponsiveQuery';
import { keys, not, reject } from 'ramda';

const usePrequalPhoneLookupWorkflow = () => {
  const { isGroupEnabled } = useFeature();
  const { prequalificationId, hasOffer } = useSelector(selectPrequalOffer);
  const { isMobile } = useResponsiveQuery();
  const { isEnabled } = useFeature();

  const getWorkflow = useCallback((): Workflow => {
    const stepsEnabled = {
      [Step.CARD_SELECTOR]: isEnabled('cardSelector'),
      [Step.CONSUMER_SEARCH]: true,
      [Step.PREQUAL_OFFER_APPLICATION]: true,
      [Step.APPLICATION]: true,
      // Credit application has a second step, whereas prequalification
      // does not.
      [Step.APPLICATION_2]: !prequalificationId && !hasOffer && isMobile,
      [Step.ADD_ONS]: isGroupEnabled(FeatureGroups['add-ons']),
      [Step.REVIEW_TERMS]: true,
    };
    const firstStep = ((keys(
      reject(not, stepsEnabled),
    ) as unknown) as Step[])[0];
    return {
      stepsEnabled: stepsEnabled,
      paths: {
        [Step.CARD_SELECTOR]: '/card-selector',
        [Step.CONSUMER_SEARCH]: '/prequal/consumer-search',
        [Step.PREQUAL_OFFER_APPLICATION]: '/prequal/offer-application',
        [Step.APPLICATION]: '/prequal/application',
        [Step.ADD_ONS]: '/add-ons',
        [Step.REVIEW_TERMS]: '/prequal/review-terms',
        ...{
          [firstStep]: '/prequal/phone-lookup',
        },
      },
      progressStartStep: Step.PREQUAL_OFFER_APPLICATION,
      restartStep: firstStep,
      timeoutRestartPath: '/prequal/phone-lookup',
    };
  }, [hasOffer, isEnabled, isGroupEnabled, isMobile, prequalificationId]);

  return getWorkflow;
};

export default usePrequalPhoneLookupWorkflow;
